module.exports = __webpack_public_path__ + "static/media/garment_sewing.739e206d.jpg";